import {Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {UserReportGrid} from "./grid";
import {submitUserReport} from "../../../services/report/user";
import SelectInput from "../../system/select";
import {getPersonsNameAndFamily, getPersonsNationalCode, getPersonsPhone} from "../../../services/profile/profile";
import Dict from "../../../helper/dict";
import {CardFooterPaginator} from "../../system/cardFooterPaginator";
import {getProvinces} from "../../../services/province/province";
import FromToNumberField from "../../system/fromToNumberField";
import FromToDateField from "../../system/fromToDateField";
import {downloadFile} from "../../../config";
import {PaginateContext} from "../../../context/paginate";

export function UserReportManagement() {

  const [userReport, setUserReport] = useState([]);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);

  const [personId, setPersonId] = useState(null);
  const [phone, setPhone] = useState(null);
  const [provinceId, setProvinceId] = useState(null);
  const [minBalance, setMinBalance] = useState(null);
  const [maxBalance, setMaxBalance] = useState(null);
  const [firstLoginFrom, setFirstLoginFrom] = useState("")
  const [firstLoginTo, setFirstLoginTo] = useState("")
  const [lastLoginFrom, setLastLoginFrom] = useState("")
  const [lastLoginTo, setLastLoginTo] = useState("")

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(data, paginate) {
    const result = await submitUserReport(data, paginate);
    if (result.status === 200) {
      const {user_report, total_count} = result.data;
      setUserReport(user_report || []);
      setGridTotalRowCount(total_count);
    }
  }

  const filter = () => {
    const data = {}
    if (personId) {
      data.person_id = personId;
    }

    if (phone) {
      data.phone = phone;
    }

    if (provinceId) {
      data.province_id = provinceId;
    }

    if (minBalance) {
      data.min_balance = parseInt(minBalance);
    }

    if (maxBalance) {
      data.max_balance = parseInt(maxBalance);
    }

    if (firstLoginFrom) {
      data.first_login_from = firstLoginFrom;
    }

    if (firstLoginTo) {
      data.first_login_to = firstLoginTo;
    }

    if (lastLoginFrom) {
      data.last_login_from = lastLoginFrom;
    }

    if (lastLoginTo) {
      data.last_login_to = lastLoginTo;
    }

    return data
  };

  useEffect(() => {
    const data = filter()
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(data, paginate)
  }, [personId, provinceId, minBalance, maxBalance, firstLoginFrom, lastLoginFrom, firstLoginTo, lastLoginTo, gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <PaginateContext.Provider value={{
      setSortBy: setSortBy,
      sortType: sortType,
      setSortType: setSortType,
      active: gridCurrentPage,
      setActive: setGridCurrentPage,
      totalRows: gridTotalRowCount,
      rowsCount: gridRowCount,
      setRowsCount: setGridRowCount,
      from: from,
      to: to,
    }}>
      <div className="w-full">
        <Card className="pt-8 w-full">
          <CardHeader floated={true} shadow={false} className="rounded-none w-full">
            <div className="mb-8 flex items-center justify-between gap-8">
              <Typography variant="h5" color="blue-gray">کاربران</Typography>
            </div>

          </CardHeader>
          <CardBody className="overflow-x-auto w-full">

            <div className="grid grid-cols-1 gap-2 mb-2 md:grid-cols-3 xxl:grid-cols-3">

              <div className="flex flex-col">
                <SelectInput
                  label={"نام"}
                  defaultValue={personId}
                  refreshSignal={personId}
                  // multiselect={false}
                  autoLoadService={getPersonsNameAndFamily}
                  autoLoadRender={({name, family, phone}) => {
                    const fullName = `${name?.trim()} ${family?.trim()}`.trim();
                    return fullName + " - " + phone
                  }}
                  onChange={setPersonId}
                />
              </div>

              <div className="flex flex-col">
                <SelectInput
                  label={Dict("phone")}
                  defaultValue={personId}
                  refreshSignal={personId}
                  autoLoadService={getPersonsPhone}
                  autoLoadRender={({phone}) => {
                    return phone
                  }}
                  onChange={setPersonId}
                />
              </div>

              <div className="flex flex-col">
                <SelectInput
                  label={Dict("national_code")}
                  defaultValue={personId}
                  refreshSignal={personId}
                  autoLoadService={getPersonsNationalCode}
                  autoLoadRender={({national_code}) => {
                    return national_code
                  }}
                  onChange={setPersonId}
                />
              </div>

              <div className="flex flex-col">
                <SelectInput
                  label={Dict("province")}
                  defaultValue={provinceId}
                  autoLoadService={getProvinces}
                  autoLoadRender={({title}) => {
                    return title
                  }}
                  onChange={setProvinceId}
                />
              </div>

            </div>

            <div className="grid grid-cols-1 gap-1 mb-2 md:grid-cols-2 xxl:grid-cols-2">
              <FromToNumberField
                label="موجودی"
                fromNumber={minBalance}
                setFromNumber={setMinBalance}
                toNumber={maxBalance}
                setToNumber={setMaxBalance}
              />

              <FromToDateField
                label="اولین ورود"
                fromDate={firstLoginFrom}
                setFromDate={setFirstLoginFrom}
                toDate={firstLoginTo}
                setToDate={setFirstLoginTo}
              />

              <FromToDateField
                label="آخرین ورود"
                fromDate={lastLoginFrom}
                setFromDate={setLastLoginFrom}
                toDate={lastLoginTo}
                setToDate={setLastLoginTo}
              />
            </div>

            <div className="flex flex-row justify-between">
              <Button variant="gradient" color="gray" onClick={() => {
                setPersonId(null)
                setProvinceId(null)
                setMinBalance(null)
                setMaxBalance(null)
                setFirstLoginFrom("")
                setFirstLoginTo("")
                setLastLoginFrom("")
                setLastLoginTo("")
              }} className="ml-1">
                <span>حذف فیلتر</span>
              </Button>

              {userReport.length > 0 &&
                <Button size="sm" variant="outlined" onClick={() => {
                  const data = filter();
                  downloadFile("user_report_excel", data, "users")
                }}>
                  خروجی اکسل
                </Button>
              }
            </div>

            <UserReportGrid
              userReport={userReport}
            />
          </CardBody>
          <CardFooterPaginator/>
        </Card>
      </div>
    </PaginateContext.Provider>
  )
    ;
}